import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';
import { Mermaid } from 'backstage-plugin-techdocs-addon-mermaid';

// Shared by the standalone docs reader (App.tsx) and the entity Docs tab
// (EntityPage.tsx), so both render docs the same way. Mermaid turns ```mermaid
// fenced blocks into diagrams and picks Mermaid's light or dark theme from the
// active Backstage theme.
export const techDocsAddons = (
  <TechDocsAddons>
    <ReportIssue />
    <Mermaid />
  </TechDocsAddons>
);
